  /**
   * -----------------------------------------
   * SUMMARY TABLE
   * -----------------------------------------
   */

  const summaryColumns = [
    {
      title: "Session Start",
      dataIndex: "sessionStart",
    },

    {
      title: "Session End",
      dataIndex: "sessionEnd",
    },

    {
      title: "Overall Duration",
      dataIndex: "overallDuration",
    },

    {
      title: "Chat Time",
      dataIndex: "chatDuration",
    },

    {
      title: "Projects Time",
      dataIndex: "projectsDuration",
    },
  ];

  /**
   * -----------------------------------------
   * VIEW TABLE
   * -----------------------------------------
   */

  const viewsColumns = [
    {
      title: "View",
      dataIndex: "view",
    },

    {
      title: "Start",
      dataIndex: "start",
    },

    {
      title: "End",
      dataIndex: "end",
    },

    {
      title: "Duration",
      dataIndex: "duration",
    },
  ];

  /**
   * -----------------------------------------
   * FILTER TABLE
   * -----------------------------------------
   */

  const filtersColumns = [
    {
      title: "Filter",
      dataIndex: "filter",
    },

    {
      title: "Opened At",
      dataIndex: "openedAt",
    },

    {
      title: "Closed At",
      dataIndex: "closedAt",
    },

    {
      title: "Duration",
      dataIndex: "duration",
    },
  ];

  /**
   * -----------------------------------------
   * PROPERTY TABLE
   * -----------------------------------------
   */

  const propertiesColumns = [
    {
      title: "Property",
      dataIndex: "property",
    },

    {
      title: "Viewed At",
      dataIndex: "viewedAt",
    },
  ];


  export default { summaryColumns, viewsColumns, filtersColumns, propertiesColumns };